import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Grid } from '@material-ui/core';

import { QueryFilter, QUERY_FILTER_BOOKSTORE, CardBigNumbers } from '../../../shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedBookstore } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreSalesCurrentYearProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreSalesCurrentYearState {
    isUpdate: boolean,
    customFilter: {
        isChart: boolean
    },
}

const BOOKSTORE_SALES_CURRENT_YEAR = gql`
query bookstoreSalesCurrentYear($customFilter:  BookstoreCustomFilter) {
    bookstoreSalesCurrentYear(bookstoreCustomFilter: $customFilter) {
		billing_current,
        billing_last,
        volume_current,
        volume_last,
        avg_price_current,
        avg_price_last
  }
}
`;

export class BookstoreSalesCurrentYear extends React.Component<IBookstoreSalesCurrentYearProps, IBookstoreSalesCurrentYearState> {

    constructor(props: IBookstoreSalesCurrentYearProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          },
          isUpdate: false,
    }
}

    public render() {
        const jsonFilter = {
          "customFilter": {
            "isChart": this.state.customFilter.isChart,
          }
        };

        return (
            <Query query={QUERY_FILTER_BOOKSTORE} notifyOnNetworkStatusChange={true}>
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                    let dataCache = GetCacheIfExists('bookstore-data');
                    const hasNoFilterAppliedBookstore = HasNoFilterAppliedBookstore(clientC);

                    if( hasNoFilterAppliedBookstore && dataCache != null && dataCache.bookstoreSalesCurrentYear != null ) {
                        return this.dataToRend(dataCache, false, cache);
                    } else {
                        return (
                            <Query query={BOOKSTORE_SALES_CURRENT_YEAR} variables={QueryFilter.getFilterBookstore(clientC, jsonFilter, [])}>
                                {({ loading, error, data}) => {

                                    if ( hasNoFilterAppliedBookstore && data != null && data.bookstoreSalesCurrentYear != null ) {
                                        if(dataCache != null && dataCache !== undefined) {
                                            dataCache.bookstoreSalesCurrentYear = data.bookstoreSalesCurrentYear;
                                        } else {
                                            dataCache = data;
                                        }
                                        SetDataToSession('bookstore-data', dataCache);
                                    }

                                    return this.dataToRend(data, loading, cache);
                                }}
                            </Query>
                        );
                    }

                }}
            </Query>
        )
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any, cache:any) {
        let billingCurrent = null;
        let billingLast = null;
        
        let volumeCurrent = null;
        let volumeLast = null;
        
        let avgPriceCurrent = null;

        if(data && data.bookstoreSalesCurrentYear) {
            billingCurrent = data.bookstoreSalesCurrentYear.billing_current ? 
                data.bookstoreSalesCurrentYear.billing_current.toString() : null;
            billingLast = data.bookstoreSalesCurrentYear.billing_last ? 
                data.bookstoreSalesCurrentYear.billing_last.toString() : null;

            volumeCurrent = data.bookstoreSalesCurrentYear.volume_current ? 
                data.bookstoreSalesCurrentYear.volume_current.toString() : null;
            volumeLast = data.bookstoreSalesCurrentYear.volume_last ? 
                data.bookstoreSalesCurrentYear.volume_last.toString() : null;

            avgPriceCurrent = data.bookstoreSalesCurrentYear.avg_price_current ? 
                data.bookstoreSalesCurrentYear.avg_price_current.toString() : null;
        }

        return  (
            <Grid container={true} spacing={16}>
                <Grid item={true} xs={4} sm={4} >
                    <CardBigNumbers 
                        title='Faturamento' 
                        loading={loading} 
                        firstValue={billingCurrent}
                        secondValue={billingLast}
                        conversionType='MoneyLessBRL' 
                    />
                </Grid>
                <Grid item={true} xs={4} sm={4} >
                    <CardBigNumbers 
                        title='Volume' 
                        loading={loading} 
                        firstValue={volumeCurrent}
                        secondValue={volumeLast}
                        conversionType='NumberLessBRL' 
                    />
                </Grid>
                <Grid item={true} xs={4} sm={4} >
                    <CardBigNumbers 
                        title='Preço Médio' 
                        loading={loading} 
                        firstValue={avgPriceCurrent}
                        conversionType='MoneyFullBRL' 
                    />
                </Grid>
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/bookstore/sale/sales-current-year/BookstoreSalesCurrentYear.tsx